import store from "@/store/index";
import config from "./config";
function formatFileType(fileurl) {
  let splitUrl = fileurl.split(".");
  return splitUrl.length > 0 ? splitUrl[splitUrl.length - 1].toLowerCase() : "";
}
function formatNumber(n) {
  const str = n.toString();
  return str[1] ? str : `0${str}`;
}
function formatTimeLimit(timelimit) {
  let sec = timelimit % 60;
  timelimit = timelimit / 60;
  let min, hour;
  if (timelimit >= 60) {
    min = timelimit % 60;
    timelimit = parseInt(timelimit / 60);
    if (timelimit >= 0) {
      hour = parseInt(timelimit);
    }
  }
  return `${hour ? hour + "小时" : ""}${min ? min + "分钟" : ""}${
    sec === 0 && !min && !hour ? "无限制" : sec === 0 ? "" : sec + "秒"
    }`;
}
export function formatUrlWstoken(url) {
  const wstoken = store.state.auth.userinfo.wstoken;
  let urlWebService = "";
  let urlAfter;
  if (url.indexOf("webservice") === -1) {
    console.log("has webservice");
    if (url.indexOf("pluginfile.php") === -1) {
    } else {
      urlWebService = url.replace(
        /pluginfile\.php/,
        "webservice/pluginfile.php"
      );
    }
  } else {
    urlWebService = url;
  }
  if (urlWebService.indexOf("?") !== -1) {
    urlAfter = `${urlWebService}&token=${wstoken}`;
  } else {
    urlAfter = `${urlWebService}?token=${wstoken}`;
  }
  if (url.indexOf("forcedownload") !== -1) {
    urlAfter = `${urlAfter}&forcedownload=0`;
  }
  return urlAfter;
}
export function formatTime(date, formatStr = "/", isSecond = true) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();

  const t1 = [year, month, day].map(formatNumber).join(formatStr);
  let t2 = "";
  if (isSecond) {
    t2 = [hour, minute, second].map(formatNumber).join(":");
  } else {
    t2 = [hour, minute].map(formatNumber).join(":");
  }

  return `${t1} ${t2}`;
}
export function trimhtml(str) {
  return str.replace(/<\/?.+?>/g, "");
}

export function fomatSocketTime() {
  return parseInt(new Date().getTime() / 1000);
}
// 随机点名时间格式化
export function formatDate(date) {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const hour = date.getHours();
  const minute = date.getMinutes();

  const t1 = [year, month, day].map(formatNumber).join(".");
  const t2 = [hour, minute].map(formatNumber).join(":");

  return `${t1} ${t2}`;
}
export function getIconFile(filename) {
  const splitUrl = filename.split(".");
  const format = splitUrl[splitUrl.length - 1].toLowerCase();
  let type = "other";
  switch (format) {
    case "doc":
    case "docx":
      type = "doc";
      break;
    case "xls":
    case "xlsx":
      type = "xls";
      break;
    case "ppt":
    case "pptx":
      type = "ppt";
      break;
    case "pdf":
      type = "pdf";
      break;
    case "mp4":
      type = "mp4";
      break;
    case "mp3":
      type = "mp3";
      break;
    case "txt":
      type = "txt";
      break;
    case "jpg":
    case "jpeg":
      type = "jpg";
      break;
    case "png":
      type = "png";
      break;
    case "gif":
      type = "gif";
      break;
  }

  return `/static/images/icon/files/icon_file_${type}.png`;
}
/**
 * 预处HTML
 * 功能:
 * 1. 附件添加token
 */
export function preTreatTopicHtml(html) {
  const wstoken = store.state.auth.userinfo.wstoken;
  const sourceRegx = /src="http[s]?:\/\/(([^"]*).scnu.edu.cn|([^"]*).wakeychan.com)\/([^"]*)\.([^"]*)"/g;
  const urlRegx = /"([^"]*)"$/g;
  let hmatch = html.match(sourceRegx) || [];
  hmatch.forEach(v => {
    v.match(urlRegx);
    let urlBefore = urlRegx.exec(v)[1];
    let urlWebService = "";
    let urlAfter;
    if (urlBefore.indexOf("webservice") === -1) {
      if (urlBefore.indexOf("pluginfile.php") === -1) {
      } else {
        urlWebService = urlBefore.replace(
          /pluginfile\.php/,
          "webservice/pluginfile.php"
        );
      }
    } else {
      urlWebService = urlBefore;
    }
    if (urlBefore.indexOf("?") !== -1) {
      urlAfter = `${urlWebService}&token=${wstoken}`;
      urlBefore = urlBefore.replace(/\?/g, "\\?");
    } else {
      urlAfter = `${urlWebService}?token=${wstoken}`;
    }
    html = html.replace(new RegExp(urlBefore, "g"), urlAfter);
  });
  return html;
}
// 格式化文件大小
export function renderSize(value) {
  if (!value && typeof value !== "number") {
    return "0 Bytes";
  }
  var unitArr = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  var index = 0;
  var srcsize = parseFloat(value);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  var size = srcsize / Math.pow(1024, index);
  size = size.toFixed(2); // 保留的小数位数
  return size + unitArr[index];
}
/**
 * 预处数据(讨论区attachments)
 * 功能:
 * 附件数据格式整理
 */
export function formatAttachments(attachments = []) {
  return attachments.map(({ filename, filesize, fileurl }) => {
    return {
      filename,
      // filesize: this.renderSize(filesize),
      fileurl:
        (fileurl.indexOf("://tmp/") === -1 ||
          fileurl.indexOf("wxfile://") === -1) &&
          fileurl.indexOf(config.baseRealm) !== -1
          ? `${fileurl}?token=${store.state.auth.userinfo.wstoken}`
          : fileurl,
      // fileicon: this.getIconFile(fileurl.replace("?forcedownload=1", "")),
      fileSize: filesize
    };
  });
}

export function calRestDayByTimestamp(unixTimeStamp) {
  return Math.round(
    (unixTimeStamp - Math.round(Date.now() / 1000)) / 3600 / 24
  );
}
export function formatNormalDate(
  date,
  isUnixTimestamp = true,
  isFairy = false
) {
  if (!(date instanceof Date)) {
    date = new Date(isUnixTimestamp ? parseInt(date) * 1000 : parseInt(date));
  }
  if (date.toString() === "Invalid Date") {
    return ""; // 无效时间
  }

  const hm = `${this.prefixNum(date.getHours())}:${this.prefixNum(
    date.getMinutes()
  )}`;

  const dateStr = `${this.prefixNum(date.getMonth() + 1)}月${this.prefixNum(
    date.getDate()
  )}日`;
  if (this.isSameYear(new Date(), date) && !isFairy) {
    return `${dateStr} ${hm}`;
  } else {
    return `${date.getFullYear()}-${this.prefixNum(
      date.getMonth() + 1
    )}-${this.prefixNum(date.getDate())} ${hm}`;
  }
}
// 获取测验反馈的匹配url
export function outcomediv(html) {
  const outcomedivReg = /<div class="outcome[\w\W]*<\/div>/;
  return html.match(outcomedivReg)
    ? this.preTreatTopicHtml(html.match(outcomedivReg)[0]).replace(
      /写评语或修改得分/,
      ""
    )
    : "";
}
export function escape2Html(str) {
  const arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
  return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
    return arrEntities[t];
  });
}
/*
 * 补充0的格式化数字
 */
export function prefixNum(num, length = 2) {
  return ("0".repeat(length) + num).substr(-length);
}
export function isSameYear(a, b) {
  return a.getFullYear() === b.getFullYear();
}
/*
 * 判断是不是B是不是A的昨天
 */
export function isYesterday(a, b) {
  return this.getDayMargin(a, b) === 1;
}
/*
 * 判断是不是同一周的两日期
 */
export function isSameWeek(a, b) {
  return (
    parseInt((this.getUnixDayCount(a) + 4) / 7) ===
    parseInt((this.getUnixDayCount(b) + 4) / 7)
  );
}
/*
 * 判断是不是同一天的两日期
 */
export function isToday(a, b) {
  return this.getDayMargin(a, b) === 0;
}
/*
 * 计算两日期间隔的天数
 */
export function getDayMargin(a, b) {
  return this.getUnixDayCount(a) - this.getUnixDayCount(b);
}
/*
 * 获取是星期几
 */
export function getDayChr(date) {
  return "日一二三四五六"[date.getDay()];
}
/*
 * 计算Unix基础时间到指定日期的天数
 */
export function getUnixDayCount(a) {
  let time = new Date(`${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`);
  return parseInt(time.getTime() / (3600000 * 24));
}
/**
 * 获得成绩的水平，才能在视图中显示出不同颜色来
 * @param {Number|String} grade 分数
 * @return {String}
 */
export function getGradeLevel(grade) {
  grade = parseInt(grade);
  if (isNaN(grade)) return "default";

  if (grade >= 90) return "90";
  else if (grade < 90 && grade >= 80) return "80";
  else if (grade < 80 && grade >= 70) return "70";
  else if (grade < 70 && grade >= 60) return "60";
  else if (grade < 60) return "failed";
}
/**
 * 格式化日期时间
 * 参考新浪微博的设计
 *
 * 输出参考:
 * 与现在差60秒内: 23秒前
 * 与现在差60分钟内: 33分钟前
 * 昨今两天: 今天 12:34
 * 今年: 8月9日 12:34
 * 跨年: 2016-08-08 12:34
 */
export function formatDateTime(date, isUnixTimestamp = true) {
  const nowDate = new Date();
  if (!(date instanceof Date)) {
    date = new Date(isUnixTimestamp ? parseInt(date) * 1000 : parseInt(date));
  }
  if (date.toString() === "Invalid Date") {
    return ""; // 无效时间
  }

  let margin = nowDate.getTime() - date.getTime(); // 时间差
  if (margin < 0) margin = 0; // 消除服务器和手机时间差导致的负数

  if (margin < 60000) {
    // 秒
    return `${Math.round(margin / 1000)}秒前`;
  } else if (margin < 3600000) {
    // 分钟
    return `${Math.round(margin / 60000)}分钟前`;
  } else {
    const hm = `${this.prefixNum(date.getHours())}:${this.prefixNum(
      date.getMinutes()
    )}`;

    if (this.isToday(nowDate, date)) {
      // 近两天
      return `今天 ${hm}`;
    } else if (this.isYesterday(nowDate, date)) {
      // 近两天
      return `昨天 ${hm}`;
    } else if (this.isSameYear(nowDate, date)) {
      const dateStr = `${date.getMonth() + 1}月${date.getDate()}日`;
      return `${dateStr} ${hm}`;
    } else {
      const dateStr = `${this.prefixNum(date.getMonth() + 1)}-${this.prefixNum(
        date.getDate()
      )}`;
      return `${date.getFullYear()}-${dateStr} ${hm}`;
    }
  }
}
/**
 * 聊天的格式化日期时间
 * 参考微信的设计
 *
 * 输出参考:
 * 今天的时间: 12:06
 * 昨天的时间: 昨天 08:12
 * 本周其他天数: 周三 12:34
 * 今年: 8月9日 12:34
 * 跨年: 2016年08月08日 12:34
 */
export function formatChatTime(unixTimeStamp) {
  const targetDate =
    typeof unixTimeStamp === "object"
      ? unixTimeStamp
      : new Date(unixTimeStamp * 1000);
  const nowDate = new Date();

  const hm = `${this.prefixNum(targetDate.getHours())}:${this.prefixNum(
    targetDate.getMinutes()
  )}`;

  // 是今天
  if (this.isToday(nowDate, targetDate)) {
    return hm;
  } else if (this.isYesterday(nowDate, targetDate)) {
    return `昨天 ${hm}`;
  } else if (this.isSameWeek(nowDate, targetDate)) {
    return `周${this.getDayChr(targetDate)} ${hm}`;
  } else {
    const dateStr = `${targetDate.getMonth() + 1}月${targetDate.getDate()}日`;
    if (this.isSameYear(nowDate, targetDate)) {
      return `${dateStr} ${hm}`;
    } else {
      return `${targetDate.getFullYear()}年${dateStr} ${hm}`;
    }
  }
}
export function handleMessageToText(html) {
  const img = /<img[^>]*>/;
  const video = /<video[^>]*>/;
  const deplace = /<[^>]+>/g;
  let imgArr = html.match(img) || [];
  let videoArr = html.match(video) || [];
  if (imgArr.length || videoArr.length) {
    return "[图片/视频/文件]";
  } else {
    return html.replace(deplace, "");
  }
}
export function formatFileTypeLimit(filetext) {
  const archive =
    " .7z .bdoc .cdoc .ddoc .gtar .tgz .gz .gzip .hqx .rar .sit .tar .zip .mn ";
  const document = " .doc .docx .epub .gdoc .odt .ott .oth .pdf .rtf ";
  const html_track = " .vtt ";
  const image =
    " .ai .bmp .gdraw .gif .ico .jpe .jpeg .jpg .pct .pic .pict .png .svg .svgz .tif .tiff ";
  const web_image = " .gif .jpe .jpeg .jpg .png .svg .svgz ";
  const presentation =
    " .gslides .odp .otp .pps .ppt .pptx .pptm .potx .potm .ppam .ppsx .ppsm .pub .sxi .sti ";
  const spreadsheet = " .csv .gsheet .ods .ots .xls .xlsx .xlsm ";
  const web_file = " .css .html .xhtml .htm .js .scss ";
  const html_video = " .mov .mp4 .m4v .ogv .webm ";
  const html_audio = " .aac .flac .mp3 .m4a .oga .ogg .wav ";
  const video =
    " .3gp .avi .dv .dif .flv .f4v .mov .movie .mp4 .m4v .mpeg .mpe .mpg .ogv .qt .rmvb .rv .swf .swfl .webm .wmv .asf ";
  const web_video =
    " .avi .flv .f4v .mov .mp4 .m4v .mpeg .mpe .mpg .ogv .qt .swf .swfl .webm ";
  const web_audio = " .aac .flac .mp3 .m4a .oga .ogg .ra .wav ";
  const audio =
    " .aac .aif .aiff .aifc .au .flac .m3u .mp3 .m4a .oga .ogg .ra .ram .rm .wav .wma ";
  if (filetext && filetext !== "*") {
    filetext = filetext.replace(/archive/g, archive);
    filetext = filetext.replace(/document/g, document);
    filetext = filetext.replace(/html_track/g, html_track);
    filetext = filetext.replace(/image/g, image);
    filetext = filetext.replace(/web_image/g, web_image);
    filetext = filetext.replace(/presentation/g, presentation);
    filetext = filetext.replace(/spreadsheet/g, spreadsheet);
    filetext = filetext.replace(/web_file/g, web_file);
    filetext = filetext.replace(/html_video/g, html_video);
    filetext = filetext.replace(/video/g, video);
    filetext = filetext.replace(/web_video/g, web_video);
    filetext = filetext.replace(/web_audio/g, web_audio);
    filetext = filetext.replace(/audio/g, audio);
    filetext = filetext.replace(/html_audio/g, html_audio);
    return filetext;
  } else {
    return "";
  }
}
/**
 * 解析文件类型
 * @param {filename} 文件名
 * @returns {type, tname } 文件类型 文件类型名称
 */
export function matchIconType(filename) {
  if (filename === "白板") {
    return { type: "whiteboard", tname: filename, iconType: "whiteboard" };
  }
  const splitUrl = filename.split(".");
  const format = splitUrl[splitUrl.length - 1].toLowerCase();
  var iconType = "other";
  var type = "";
  var tname = "其他";
  var limitSiz = 10;
  switch (format) {
    case "doc":
    case "docx":
      type = "word";
      iconType = "word";
      tname = "word";
      break;
    case "xlsx":
    case "xls":
    case "csv":
      type = "excel";
      iconType = "excel";
      tname = "excel";
      break;
    case "ppt":
    case "pptx":
      limitSiz = 50;
      type = "ppt";
      tname = "ppt";
      iconType = "ppt";
      break;
    case "pdf":
      type = "pdf";
      tname = "pdf";
      iconType = "pdf";
      break;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      type = "image";
      tname = "图片";
      iconType = "image";

      break;
    case "mp4":
    case "movie":
    case "mpeg":
    case "mov":
    case "avi":
      type = "video";
      tname = "视频";
      limitSiz = 50;
      break;
    case "mp3":
      type = "audio";
      tname = "音频";
      limitSiz = 50;
      break;
    case "whiteboard":
      type = "whiteboard";
      tname = "白板";
      iconType = "whiteboard";
      break;
  }
  console.log("filename", filename);
  console.log("type", type);
  return { type, tname, iconType, limit: limitSiz };
}
//计算宽
export function widths(screenWidth, imgWidth) {
  //屏幕宽
  if (screenWidth <= imgWidth) {
    return screenWidth //rpx
  } else {
    return screenWidth
    // return imgWidth
  }
}
//计算高
export function heights(screenWidth, imgHeight, imgWidth) {
  const res = uni.getSystemInfoSync()
  if (screenWidth <= imgWidth) {
    let b = Math.floor(screenWidth / imgWidth)
    return b * imgHeight
  } else {
    // return imgHeight
    let b = Math.floor(screenWidth / imgWidth)
    return b * imgHeight
  }
}
export function resizImage(imageSize, w, h) {
  if (imageSize.width < w) {
    if (imageSize.height < h) {
      var scale1 = imageSize.height / imageSize.width
      var scale2 = h / imageSize.height
      if (scale1 > scale2) {
        imageSize.height = (imageSize.height / imageSize.width) * w
        imageSize.width = w
      } else {
        imageSize.width = (imageSize.width / imageSize.height) * h
        imageSize.height = h
      }
    } else {
      imageSize.height = (imageSize.height / imageSize.width) * w
      imageSize.width = w
    }
  } else if (imageSize.height < h) {
    if (imageSize.width < w) {
      var scale1 = imageSize.height / imageSize.width
      var scale2 = h / imageSize.height
      if (scale1 > scale2) {
        imageSize.height = (imageSize.height / imageSize.width) * w
        imageSize.width = w
      } else {
        imageSize.width = (imageSize.width / imageSize.height) * h
        imageSize.height = h
      }
    } else {
      imageSize.width = (imageSize.width / imageSize.height) * h
      imageSize.height = h
    }
  } else {
    var scale1 = imageSize.height / imageSize.width
    var scale2 = h / imageSize.height
    if (scale1 > scale2) {
      imageSize.height = (imageSize.height / imageSize.width) * w
      imageSize.width = w
    } else {
      imageSize.width = (imageSize.width / imageSize.height) * h
      imageSize.height = h
    }
  }
  console.log('改变imageSize', imageSize.width, imageSize.height)
  return imageSize
}
export default {
  formatAttachments,
  formatFileType,
  formatTimeLimit,
  formatFileTypeLimit,
  formatNumber,
  formatTime,
  formatDate,
  getIconFile,
  preTreatTopicHtml,
  calRestDayByTimestamp,
  formatNormalDate,
  escape2Html,
  prefixNum,
  isSameYear,
  getGradeLevel,
  renderSize,
  formatDateTime,
  isToday,
  getDayMargin,
  getUnixDayCount,
  trimhtml,
  fomatSocketTime,
  formatUrlWstoken,
  outcomediv,
  formatChatTime,
  isYesterday,
  isSameWeek,
  getDayChr,
  handleMessageToText,
  matchIconType,
  widths,
  heights,
  resizImage
};
